import toast, { Toast } from 'react-hot-toast'
import { ToastCard } from '../Toast'
import type { SuccessToastOptions } from './SuccessToast.types'

export function showSuccessToast({ message, description, duration = 5000, action, icon, tone, focusAction }: SuccessToastOptions) {
  return toast.custom(
    (t: Toast) => (
      <ToastCard
        kind="success"
        title={message}
        description={description}
        icon={icon}
        tone={tone}
        action={action && {
          label: action.label,
          onClick: async () => {
            toast.dismiss(t.id)
            await action.onClick()
          },
        }}
        focusAction={focusAction}
        onDismiss={() => toast.dismiss(t.id)}
      />
    ),
    { duration }
  )
}
